import { useRef } from "react";
import Keyframe, { PX_PER_SEC } from "./Keyframe";

export default function TrackRow({ label, keyframes, duration, onMoveKeyframe, onDeleteKeyframe, onEasingChange, onDragStart, onDragEnd }) {
  const trackRef = useRef(null);
  const width = Math.max(duration * PX_PER_SEC, 400);

  return (
    <div className="flex items-stretch border-b border-[#145A43]/30">
      <div className="w-32 shrink-0 px-3 py-2 text-xs text-[#D7C7A1]/70 bg-[#0F0F0F] sticky left-0 z-10 flex items-center">
        {label}
      </div>
      <div
        ref={trackRef}
        className="relative flex-1 bg-[#0B3D2E]/10"
        style={{ width: `${width}px`, height: "32px" }}
      >
        {keyframes.map((kf, i) => (
          <Keyframe
            key={`${kf.time}-${i}`}
            kf={kf}
            trackRef={trackRef}
            onMove={(t) => onMoveKeyframe(kf.time, t)}
            onDelete={() => onDeleteKeyframe(kf.time)}
            onEasingChange={(easing) => onEasingChange(kf.time, easing)}
            onDragStart={onDragStart}
            onDragEnd={onDragEnd}
          />
        ))}
      </div>
    </div>
  );
}
